module.exports = __webpack_public_path__ + "img/PatelR.2f5326f6.jpg";